// ###########################################################################
// HEADER - Add class .min to scroll down
$(document).ready(function() {
  $(window).scroll(function() {
    var scrollPosition = $(window).scrollTop();

    if (scrollPosition > 300) {
      $('.main-header').addClass('min');
    } else {
      $('.main-header').removeClass('min');
    }
  });
});

// ###########################################################################
// ANIMATION FADE TO TOP - element dom
var $animation_elements = $('.animated');
var $window = $(window);

function check_if_in_view() {
    var window_height = $window.height();
    var window_top_position = $window.scrollTop();
    var window_bottom_position = (window_top_position + window_height);

    $.each($animation_elements, function() {
        var $element = $(this);
        var element_height = $element.outerHeight();
        var element_top_position = $element.offset().top;
        var element_bottom_position = (element_top_position + element_height);

        if ((element_bottom_position >= window_top_position) &&
            (element_top_position <= window_bottom_position)) {
            $element.addClass('active');
        }
    });
}

$window.on('scroll resize', check_if_in_view);
$window.trigger('scroll');

// ###########################################################################
// PRIMARY NAVIGATION
$("#btnMobile").click(function (e) {
  $(this).toggleClass("cross");
  $(".main-nav-wrapper").toggleClass("open");
  $("body").toggleClass("overflow");
});

// ###########################################################################
// SUBNAV NAVIGATION
$("ul > li.menu-item-has-children > a").click(function (e) {
    e.preventDefault();
    var LiParent =$(this).parent().attr('class');
    if(! LiParent.includes("openSub-menu") ){
        $('ul > li.menu-item-has-children > a').parent().removeClass("openSub-menu");
    }
    $(this).parent().toggleClass("openSub-menu");
});

// CLOSE NAV WHEN CLICK ANYWHERE
$(document).on("click", function (event) {
    var $trigger = $(".menu-item-has-children");
    if ($trigger !== event.target && !$trigger.has(event.target).length) {
        $(".menu-item-has-children").removeClass("openSub-menu");
    }
});

// ###########################################################################
// ANCRE
$('a[href^="#"]').on('click',function (e) {
    e.preventDefault();

    var target = this.hash,
    $target = $(target);

    $('html, body').stop().animate({
        'scrollTop': $target.offset().top - 80
    }, 1200, 'swing', function () {
        window.location.hash = target;
    });
});

// ###########################################################################
// AGENDA
function setDay(index, btn) {

  $('.prog-day-btn').removeClass('active');
  $(btn).addClass('active');

  var $wrap = $('#prog-events');

  $wrap.css({
    opacity: 0,
    transform: 'translateY(10px)'
  });

  setTimeout(function () {

    $('.prog-day-content').removeClass('active').hide();

    $('.prog-day-content[data-day="' + index + '"]')
      .addClass('active')
      .show();

    $wrap.css({
      opacity: 1,
      transform: 'translateY(0)'
    });

  }, 150);
}

// ###########################################################################
// SLICK - slideshow & slider
// ✅ PROTÉGÉ: initialiser SEULEMENT si Slick existe
if (typeof $.fn.slick !== 'undefined') {
  $(document).ready(function(){

    $('.slideshow .slider-wrapper').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      infinite: true,
      cssEase: 'ease',
      fade: true,
      speed: 1000,
    });

  });
}